(() => {
  if (window.__twrgSchemaReviews) return;
  window.__twrgSchemaReviews = true;
  const selector = 'script[type="application/ld+json"]';
  let reviewData;
  let queued = false;
  function reconcile() {
    queued = false;
    const authoritative = document.getElementById('twrg-product-schema');
    if (!authoritative) return;
    let root;
    try { root = JSON.parse(authoritative.textContent); } catch { return; }
    const product = root['@type'] === 'ProductGroup'
      ? root.hasVariant?.find(variant => variant.productID === authoritative.dataset.selectedVariantId)
      : root;
    if (product?.['@type'] !== 'Product' || !product['@id']) return;
    const canonical = new URL(product.url, location.href);
    for (const node of document.querySelectorAll(selector)) {
      if (node === authoritative) continue;
      let candidate;
      try { candidate = JSON.parse(node.textContent); } catch { continue; }
      if (candidate['@type'] !== 'Product' || candidate.offers || (!candidate.aggregateRating && !candidate.review)) continue;
      let candidateUrl;
      try { candidateUrl = new URL(candidate.url, location.href); } catch { continue; }
      if (candidateUrl.hostname !== 'twowayradiogear.myshopify.com' || candidateUrl.pathname !== canonical.pathname) continue;
      reviewData = { aggregateRating: candidate.aggregateRating, review: candidate.review };
      node.remove();
    }
    if (!reviewData) return;
    if (reviewData.aggregateRating) product.aggregateRating = reviewData.aggregateRating;
    if (reviewData.review) product.review = reviewData.review.map(review => {
      const { itemReviewed, ...nestedReview } = review;
      return nestedReview;
    });
    const text = JSON.stringify(root);
    if (authoritative.textContent !== text) authoritative.textContent = text;
  }
  function schedule() { if (!queued) { queued = true; queueMicrotask(reconcile); } }
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.target.nodeType === 1 && record.target.matches?.(selector)) { schedule(); return; }
      for (const node of record.addedNodes) {
        if (node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector))) { schedule(); return; }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  reconcile();
})();
